export function directoryReturn(location) {
  const search = typeof location === 'string' ? location : location.search;
  const path = new URLSearchParams(search).get('fromDirectory');
  return typeof path === 'string' && path.length <= 600 && /^\/(?:food-delivery(?:\/[-a-z0-9]+){0,2}|[-a-z0-9]+\/(?:category\/[-a-z0-9]+)?)(?:\?storeType=[^#\s\\]*)?$/.test(path) ? path : null;
}
export default function canReturnFromStore(location, homePath) {
  return Boolean(directoryReturn(location) || (homePath === '/' && location.key !== 'default' && !new URLSearchParams(location.search).has('q')));
}
